import { useSuspenseQuery } from "@tanstack/react-query";
import api from "apis";
import { GetGroupedTagsParams } from "apis/data-contracts";

const useTagsQuery = (options: GetGroupedTagsParams) => {
  return useSuspenseQuery({
    queryKey: api.tag.getGroupedTagsKey(options),
    queryFn: () => api.tag.getGroupedTags(options),
  });
};

export default useTagsQuery;
